import WalkthroughContent from "./WalkthroughContent";
import WalkthroughControl from "./WalkthroughControl";


export const contentPlayerPageWalkthrough = [
    
    {
        selector: '.reactour-videoplayer',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Let's Learn How To Use The Platform! This Section Plays Your Content"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        skip
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()} />
                </div>
            );
        },
        position: 'center',
    },
    {
        selector: '.reactour-tilebar',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Use This Tilebar To-Complete Quiz, View Course Details & Discover How to Unlock Free Access & Certification Milestones"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            );
        },
        position: 'center',
        // stepInteraction: false
    },
    {
        selector: '.reactour-coinscertificates',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Here You Can See Your Total Coins And Certificate Progress. Tap To View Details."} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            );
        },
        position: 'right',
        stepInteraction: false
    },
    {
        selector: '.reactour-quiz',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Complete The Quiz To Earn Certificates & Unlock Full Access For Free."} imagePosition={"center"} />
                    <WalkthroughControl
                        prev
                        end
                        onClickPrev={() => goTo(step - 2)}
                        onClickEnd={() => close()} />
                </div>
            );
        },
        position: 'right',
        // stepInteraction: false
    },
    // {
    //     selector: '',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"Let's Learn How To Use The Platform!!"} imagePosition={"center"} />
    //                 <WalkthroughControl next onClickNext={() => goTo(step)} skip onClickSkip={() => close()} />
    //             </div>
    //         );
    //     },
    //     position: 'right',
    // },
    // {
    //     selector: '.reactour-sidebar',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"Here is Your Current Microskill's content List And other Microskills List"} imagePosition={"right"} />
    //                 <WalkthroughControl
    //                     next
    //                     prev
    //                     skip
    //                     onClickNext={() => goTo(step)}
    //                     onClickPrev={() => goTo(step - 2)}
    //                     onClickSkip={() => close()} />
    //             </div>
    //         );
    //     },
    //     position: 'left',
    // },
    // {
    //     selector: '.reactour-sidebar-watched',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"Click Here To Mark A Lesson As Watched"} imagePosition={"right"} />
    //                 <WalkthroughControl
    //                     next
    //                     prev
    //                     skip
    //                     onClickNext={() => goTo(step)}
    //                     onClickPrev={() => goTo(step - 2)}
    //                     onClickSkip={() => close()} />
    //             </div>
    //         );
    //     },
    //     position: 'left',
    //     stepInteraction: false
    // },
    // {
    //     selector: '.reactour-sidebar-quiz',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"Click Here To Access Lesson's Quiz Directly To Mark Lesson As Complete"} imagePosition={"right"} />
    //                 <WalkthroughControl
    //                     next
    //                     prev
    //                     skip
    //                     onClickNext={() => goTo(step)}
    //                     onClickPrev={() => goTo(step - 2)}
    //                     onClickSkip={() => close()} />
    //             </div>
    //         );
    //     },
    //     position: 'left',
    //     stepInteraction: false
    // },
    
    // {
    //     selector: '.reactour-progress',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"Watch Video And Complete Quiz To Increase Your Progress"} imagePosition={"right"} />
    //                 <WalkthroughControl
    //                     next
    //                     prev
    //                     skip
    //                     onClickNext={() => goTo(step)}
    //                     onClickPrev={() => goTo(step - 2)}
    //                     onClickSkip={() => close()} />
    //             </div>
    //         );
    //     },
    //     position: 'left',
    //     stepInteraction: false
    // },
    // {
    //     selector: '.reactour-certificate',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"On Completing The Microskill You Can Download The Certificate From Here"} imagePosition={"right"} />
    //                 <WalkthroughControl
    //                     end
    //                     prev
    //                     onClickPrev={() => goTo(step - 2)}
    //                     onClickEnd={() => close()}
    //                 />
    //             </div>
    //         );
    //     },
    //     position: 'left',
    //     stepInteraction: false
    // },

]

export const contentPlayerPageWalkthroughMobile = [
    {
        selector: '.reactour-videoplayer',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Let's Learn How To Use The Platform! This Section Plays Your Content"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        skip
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()} />
                </div>
            );
        },
        position: 'center',
    },
    {
        selector: '.reactour-tilebar',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Use This Tilebar To-Complete Quiz, View Course Details & Discover How to Unlock Free Access & Certification Milestones"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            );
        },
        position: 'left',
        // stepInteraction: false
    },
    {
        selector: '.reactour-coinscertificates',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Here You Can See Your Total Coins And Certificate Progress. Tap To View Details."} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            );
        },
        position: 'right',
        stepInteraction: false
    },
    {
        selector: '.reactour-quiz',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Complete The Quiz To Earn Certificates & Unlock Full Access For Free."} imagePosition={"center"} />
                    <WalkthroughControl
                        end
                        prev
                        onClickPrev={() => goTo(step - 2)}
                        onClickEnd={() => close()} />
                </div>
            );
        },
        position: 'bottom',
        // stepInteraction: false
    },
    // {
    //     selector: '',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"Let's Learn How To Use The Platform!!"} imagePosition={"center"} />
    //                 <WalkthroughControl next skip onClickNext={() => goTo(step)} onClickSkip={() => close()} />
    //             </div>
    //         );
    //     },
    //     position: 'right',
    // },
    // {
    //     selector: '.reactour-videoplayer',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={'This Section Plays Your Content'} imagePosition={"center"} />
    //                 <WalkthroughControl
    //                     next skip
    //                     prev
    //                     onClickNext={() => goTo(step)}
    //                     onClickSkip={() => close()}
    //                     onClickPrev={() => goTo(step - 2)} />
    //             </div>
    //         );
    //     },
    //     position: 'right',
    // },
    // {
    //     selector: '.reactour-sidebar-next',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"Here is Your Current Microskill's content List And other Microskills List"} imagePosition={"center"} />
    //                 <WalkthroughControl
    //                     next skip
    //                     prev
    //                     onClickNext={() => goTo(step)}
    //                     onClickSkip={() => close()}
    //                     onClickPrev={() => goTo(step - 2)} />
    //             </div>
    //         );
    //     },
    //     position: 'center',
    // },
    // {
    //     selector: '.reactour-tilebar',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"Here is Your TileBar - To Access Quiz, Ask Doubts, Create Notes etc."} imagePosition={"center"} />
    //                 <WalkthroughControl
    //                     next skip
    //                     prev
    //                     onClickNext={() => goTo(step)}
    //                     onClickSkip={() => close()}
    //                     onClickPrev={() => goTo(step - 2)} />
    //             </div>
    //         );
    //     },
    //     position: 'left',
    //     stepInteraction: false
    // },
    // {
    //     selector: '.reactour-certificate',
    //     content: ({ goTo, step, close }) => {
    //         return (
    //             <div style={{ height: '100%' }}>
    //                 <WalkthroughContent text={"On Completing The Microskill You Can Download The Certificate From Here"} imagePosition={"center"} />
    //                 <WalkthroughControl
    //                     end
    //                     prev
    //                     onClickPrev={() => goTo(step - 2)}
    //                     onClickSkip={() => close()}
    //                     onClickEnd={() => close()}
    //                 />
    //             </div>
    //         );
    //     },
    //     position: 'top',
    //     stepInteraction: false
    // },
]

export const profilePageWalkthrough = [
    {
        selector: '',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Welcome To your Profile Section"} imagePosition={"center"} />
                    <WalkthroughControl
                        next skip
                        onClickSkip={() => close()}
                        onClickNext={() => goTo(step)}
                    />
                </div>
            );
        },
        position: 'center',
        // stepInteraction: false
    },
    {
        selector: '.reactour-profile-main',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To Get Your Personal Information"} imagePosition={"left"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickSkip={() => close()}
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        // stepInteraction: false
    },
    {
        selector: '.reactour-profile-certificates',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To View Your Pending And Earned Certificates To Download"} imagePosition={"left"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        // stepInteraction: false
    },
    {
        selector: '.reactour-personalize',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To View Your Personalised Courses"} imagePosition={"left"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickSkip={() => close()}
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        // stepInteraction: false
    },
    {
        selector: '.reactour-profile-analytics',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To View User Analytics And Coins Table"} imagePosition={"left"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        stepInteraction: false
    },
    {
        selector: '.reactour-profile-learning',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To View Your Learning Status"} imagePosition={"left"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        stepInteraction: false
    },
    {
        selector: '.reactour-profile-refer',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To Get Your Unique Referral Code And Share"} imagePosition={"left"} />
                    <WalkthroughControl
                        end
                        prev
                        onClickPrev={() => goTo(step-2)}
                        onClickEnd={() => close()}
                    />
                </div>
            );
        },
        position: 'left',
        stepInteraction: false
    },
]

export const profilePageMobileWalkthrough = [
    {
        selector: '',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Welcome To your Profile Section"} imagePosition={"center"} />
                    <WalkthroughControl
                        next skip
                        onClickSkip={() => close()}
                        onClickNext={() => goTo(step)}
                    />
                </div>
            );
        },
        position: 'center',
        // stepInteraction: false
    },
    {
        selector: '.reactour-profile-main',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To Get Your Personal Information"} imagePosition={"center"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickSkip={() => close()}
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        // stepInteraction: false
    },
    {
        selector: '.reactour-profile-certificates',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To View Your Pending And Earned Certificates To Download"} imagePosition={"center"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        // stepInteraction: false
    },
    {
        selector: '.reactour-personalize',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To View Your Personalised Courses"} imagePosition={"center"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickSkip={() => close()}
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        // stepInteraction: false
    },
    {
        selector: '.reactour-profile-analytics',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To View User Analytics And Coins Table"} imagePosition={"center"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        stepInteraction: false
    },
    {
        selector: '.reactour-profile-learning',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To View Your Learning Status"} imagePosition={"center"} />
                    <WalkthroughControl
                        next skip
                        prev
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()}
                        onClickPrev={() => goTo(step - 2)} />
                </div>
            );
        },
        position: 'left',
        stepInteraction: false
    },
    {
        selector: '.reactour-profile-refer',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '200%' }}>
                    <WalkthroughContent text={"Click Here To Get Your Unique Referral Code And Share"} imagePosition={"center"} />
                    <WalkthroughControl
                        end
                        prev
                        onClickPrev={() => goTo(step-2)}
                        onClickEnd={() => close()}
                    />
                </div>
            );
        },
        position: 'left',
        stepInteraction: false
    },
]
